import { onPageLoad } from '../modules/page_lifecycle.js';
import { qs, qsa } from '../modules/dom.js';

onPageLoad(() => {
  if (!qs('#company')) return;

  qsa('.clickable').forEach((row) => {
    row.addEventListener('click', () => {
      const target = row.getAttribute('data-bs-target') || row.getAttribute('data-target');
      if (!target) return;

      const parentRow = qs(`[data-bs-target="${target}"], [data-target="${target}"]`);
      if (!parentRow) return;

      parentRow.classList.toggle('open');
      const icon = parentRow.querySelector('.toggle-div i');
      icon?.classList.toggle('fa-caret-right');
      icon?.classList.toggle('fa-caret-down');
    });
  });
});
